import { useMutation } from 'react-query';

import { ConfirmVerifyEmail } from '~/../api/common.types';
import { api } from '~/client/api';

export const useConfirmEmailVerified = () => {
  return useMutation((data: ConfirmVerifyEmail) => {
    return api.confirmEmailVerified(data);
  });
};
